"use strict";

var app = new Vue({
    el: '#searchapp',
    data: {
        results: [],
        tags: [],
        types: [],
        totalCount: 0,
        filterTags: [],
        loading: true,
        busy: false,
        query: ""
    },

    mounted: function mounted() {
        var queryObj = window.data || null;
        if (queryObj !== null) {
            this.query = window.data.query;
            if (window.data.selectedTags !== null && window.data.selectedTags.length > 0) {
                for (var i = 0; i < window.data.selectedTags.length; i++) {
                    this.tags.push({
                        name: window.data.selectedTags[i],
                        selected: true
                    });
                }
            }
            if (window.data.selectedTypes !== null && window.data.selectedTypes.length > 0) {
                for (var i = 0; i < window.data.selectedTypes.length; i++) {
                    this.types.push({
                        name: window.data.selectedTypes[i],
                        selected: true
                    });
                }
            }
        }
        this.$nextTick(function () {
            this.loadMoreContent(queryObj);
        });
    },

    methods: {
        findGetParameter: function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search.substr(1).split("&").forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
            return result;
        },
        loadMoreContent: function loadMoreContent(queryData) {
            var _this = this;

            this.results = [];
            var fetchNewFromJs = this.findGetParameter('fetchNew');

            var data = {
                selectedTags: this.getSelectedTags(),
                selectedTypes: this.getSelectedTypes(),
                query: this.query,
                fetchNew: fetchNewFromJs
            };

            axios.post('/query/', data).then(function (res) {
                _this.totalCount = res.data.totalCount;
                _this.tags = res.data.tags;
                _this.types = res.data.types;
                var oldResults = _this.results;
                var newResults = res.data.searchResults;
                var newArray = oldResults.concat(newResults);
                _this.results = newArray;
                _this.loading = false;
            });
        },
        highlight: function highlight(item) {

            var regex = /(<([^>]+)>)/ig;
            var str = item.replace(regex, "");

            return str.replace(new RegExp(this.query, "gi"), function (match) {
                return '<span class="highlightText">' + match + '</span>';
            });
        },
        selectTag: function selectTag(tag) {
            this.loading = true;
            tag.selected = !tag.selected;
            this.loadMoreContent(true);
        },
        selectType: function selectType(type) {
            this.loading = true;
            type.selected = !type.selected;
            this.loadMoreContent(true);
        },
        getSelectedTags: function getSelectedTags() {
            var allSelectedTags = [];
            if (this.tags !== null && this.tags.length > 0) for (var i = 0; i < this.tags.length; i++) {
                if (this.tags[i].selected) {
                    allSelectedTags.push(this.tags[i].name);
                }
            }
            return allSelectedTags;
        },
        getSelectedTypes: function getSelectedTypes() {
            var allSelectedTypes = [];
            if (this.types !== null && this.types.length > 0) for (var i = 0; i < this.types.length; i++) {
                if (this.types[i].selected) {
                    allSelectedTypes.push(this.types[i].name);
                }
            }
            return allSelectedTypes;
        },
        getItemPath: function getItemPath(item) {
            var path = "";
            if (item.fullPaths && item.fullPaths.length > 0) {
                path = item.fullPaths[0];
            }
            return path;
        },
        getItemImage: function getItemImage(item) {
            var src = "";
            if (item.files && item.files.length > 0) {
                src = item.files[0];
            }
            return src;
        },
        strippedContent: function strippedContent(item, length) {
            var regex = /(<([^>]+)>)/ig;
            var str = item.description.replace(regex, "");
            if (str.length > length) {
                str = str.substr(0, length - 3) + "...";
            }

            return str;
        }
    }
});